(function () {
    'use strict';

    angular
        .module('iamSystemModule')
        .controller('iamSystemListController', Controller);

    Controller.$inject = ['$scope', 'bcmService'];

    function Controller($scope, bcmService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};
    }
})();